import * as axios from "axios";
import store from "redux/store";
import { LOGOUT, MESSAGE_ERROR } from "actions/types";
import { hideLoader } from "actions/types";
import CookieHelper from "helpers/cookie";

export default class BaseAPI {
  constructor() {
    this.client = null;
    this.api_url = process.env.REACT_APP_API_ENDPOINT;
  }

  init = () => {
    //this.api_token = getCookie("ACCESS_TOKEN");

    let headers = {
      Accept: "application/json",
    };

    let rawCookie = CookieHelper.getCookie("mmev_obj");
    if (typeof rawCookie != "undefined") {
      let tokenObj = JSON.parse(rawCookie);
      if (tokenObj && tokenObj.token) {
        let token = tokenObj.token;
        headers.Authorization = `Bearer ${token}`;
      }
      if (tokenObj && tokenObj.uuid) {
        let tokenuuid = tokenObj.uuid;
        headers.cauth = `${tokenuuid}`;
      }
    }
    console.debug(this.api_url);
    this.client = axios.create({
      baseURL: this.api_url,
      timeout: 31000,
      headers: headers,
      data: JSON.stringify({ bar: 123 }),
      getCookie: CookieHelper.getCookie,
      setCookie: CookieHelper.setCookie,
      setTokenCookie: CookieHelper.setTokenCookie,
    });

    this.client.interceptors.response.use(
      function (response) {
        //	console.log("RESPONSE 1", response);
        //	console.log("RESPONSE", response.data);
        //	console.log("RESPONSE", response.token_valid_till);
        let tokenObjRaw = response.config.getCookie("mmev_obj");
        let tokenObj;
        if (
          response.data.data.token_valid_till &&
          !response.data.data.token &&
          tokenObjRaw != ""
        ) {
          tokenObj = JSON.parse(tokenObjRaw);
          tokenObj.token_valid_till = response.data.data.token_valid_till;
          response.config.setCookie(
            "mmev_obj",
            JSON.stringify(tokenObj),
            response.data.data.token_valid_till
          );
        } else if (
          response.data.data.token_valid_till &&
          response.data.data.token
        ) {
          //response.config.setTokenCookie("mmev_obj", JSON.stringify(response.data.data), response.data.data.token_valid_till);
          response.config.setTokenCookie(response.data.data);
        } else if (
          response.data.token_valid_till &&
          !response.data.token &&
          tokenObjRaw != ""
        ) {
          tokenObj = JSON.parse(tokenObjRaw);
          tokenObj.token_valid_till = response.data.token_valid_till;
          response.config.setCookie(
            "mmev_obj",
            JSON.stringify(tokenObj),
            response.data.token_valid_till
          );
        }

        return response;
      },
      function (error) {
        if (
          error.response &&
          error.response.status &&
          401 == error.response.status
        ) {
          store.dispatch({ type: LOGOUT });
          error.response.data = false;
          error.response.status = 0;
          return Promise.reject(error);
        } else if (error.response && error.response.status) {
          return Promise.reject(error);
        }
        store.dispatch({
          type: MESSAGE_ERROR,
          message: "Onbekende systeem fout!!! Raadpleeg de admin",
          header: "SYSTEEM FOUT",
        });
        store.dispatch(hideLoader());
      }
    );

    return this.client;
  };

  getCategory = (params) => {
    return this.init().get("/account/product", { params: params });
  };
}
